import { useQueryParams } from '@/hooks/useQueryParams';
import {
  ARTIFACT_QUERY_PARAM,
  ArtifactType,
  isArtifactType,
} from '../contexts/ArtifactContext/artifact.lib';

type Ret = {
  artifactType: ArtifactType;
};

export const useActiveArtifactType = (): Ret => {
  const { queryParams } = useQueryParams();

  const specifiedType =
    queryParams.get(ARTIFACT_QUERY_PARAM) ?? ArtifactType.Entry;

  const artifactType = isArtifactType(specifiedType)
    ? specifiedType
    : ArtifactType.Entry;

  return { artifactType };
};
